<template>
  <div>
    <header-com></header-com>
    <van-nav-bar
      title="联系我们"
      left-text="返回"
      left-arrow
      @click-left="onTopClickLeft"
      class="custom-navbar"
    >
      <a
        :href="
          routeValue === null ||
          routeValue === undefined ||
          routeValue.length === 0
            ? 'https://www.ptty.com.cn/wap/#/'
            : 'https://www.ptty.com.cn/wap/#/' + routeValue
        "
        slot="right"
        style="font-size:20px;"
      >
        <van-icon style="font-size:20px;" name="wap-home" />
      </a>
    </van-nav-bar>

    <div class="content-card">
      <div class="contact-info">
        <p class="company-desc">
          天津跑兔体育科技有限公司，专注体育赛事系统研发，推动体育产业数字化转型。提供软件开发、销售服务。
        </p>

        <div class="contact-item">
          <span class="label">商务合作：</span>
          <span class="value bold">请添加微信客服</span>
          <span class="value phone">
            <a style="text-decoration: none;">
              15822526928
            </a>
          </span>
        </div>

        <!-- <div class="contact-item" style="margin-top:15px;">
          <span class="label">微信商城请点击：</span>
          <span class="value bold"></span>
          <span class="value phone">
            <span
              style="text-decoration: none;color: blue;"
              @click="getWxShopUrl"
            >
              跑兔装备库
            </span>
          </span>
        </div> -->
      </div>
      <div class="qrcode-section">
        <p class="section-title">
          长按二维码联系微信客户，如果二维码已经过期，请按手机号添加
        </p>
        <div class="qrcode-group">
          <div class="qrcode-item">
            <img
              src="https://www.ptty.com.cn/wap/wxkf.jpg"
              alt="微信公众号"
              class="qrcode-img"
            />
            <p class="qrcode-tip">微信客服</p>
          </div>
        </div>
      </div>
      <!-- 广告位开始 -->
      <div id="meAdDiv"></div>
      <!-- 广告位结束 -->
      <div class="qrcode-section">
        <p class="section-title">长按二维码关注我们，了解更新赛事资讯</p>
        <div class="qrcode-group">
          <div class="qrcode-item">
            <img
              src="https://www.ptty.com.cn/wap/ptCode.jpg"
              alt="微信公众号"
              class="qrcode-img"
            />
            <p class="qrcode-tip">微信公众号</p>
          </div>
          <div class="qrcode-item">
            <img
              src="https://www.ptty.com.cn/wap/spCode.png"
              alt="小程序"
              style="width:98%"
              class="qrcode-img"
            />
            <p class="qrcode-tip">微信视频号</p>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <p class="copyright">天津跑兔体育科技有限公司©版权所有</p>
      <a href="http://beian.miit.gov.cn/" target="_blank" class="beian-link"
        >津ICP备2023005649号</a
      >
    </div>

    <loading-com />
  </div>
</template>

<script>
import HeaderCom from "../commonCom/HeaderCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
export default {
  components: { HeaderCom, LoadingCom },
  name: "ConnectMe",

  data() {
    return {
      routeValue: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    setTimeout(() => {
      this.$nextTick(() => {
        this.utilPost.loadAdHandler("meAdDiv");
      });
    }, 300);
  },
  methods: {
    getWxShopUrl() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: "",
          op: this.op, //反射名称
          methodName: "wxShopeH5Url" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        window.location.href = data.content;
      });
    },
    onTopClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 全局基础样式 */
.page-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 60px; /* 避免内容被底部遮挡 */
}

/* 导航栏样式 */
.custom-navbar {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.custom-navbar .van-nav-bar__title {
  color: #333;
  font-weight: 500;
}
.custom-navbar .van-nav-bar__text {
  color: #666;
}
.custom-navbar .van-icon {
  color: #666;
  font-size: 20px;
}
.home-link {
  display: flex;
  align-items: center;
}

/* 内容卡片 */
.content-card {
  margin: 16px;
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
}

/* 公司简介 */
.company-desc {
  color: #333;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
}

/* 联系信息 */
.contact-item {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}
.contact-item .label {
  color: #999;
  margin-right: 8px;
}
.contact-item .value {
  flex: 1;
}
.contact-item .bold {
  color: #333;
  font-weight: 500;
}
.contact-item .phone {
  letter-spacing: 1px;
}

/* 二维码区域 */
.qrcode-section {
  margin-top: 24px;
}
.section-title {
  color: #333;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 16px;
}
.qrcode-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.qrcode-item {
  text-align: center;
}
.qrcode-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 8px;
}
.qrcode-tip {
  color: #666;
  font-size: 13px;
}

/* 底部版权 */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
}
.copyright {
  color: #999;
  font-size: 14px;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 0px;
}
.beian-link {
  display: block;
  color: #2d8cf0;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
}
.beian-link:hover {
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/components/MeIndex/ConnectMe.vue